import { useEffect, useRef, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { FormOption } from 'types';
import * as S from './styles';

interface Props {
  id: string;
  value: string;
  options: FormOption[];
  handleChange: (value: string) => void;
}

export function Select({ options, id, value, handleChange }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const filterSearchRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutsideFilterSearch(e: MouseEvent) {
      if (
        isOpen &&
        filterSearchRef.current &&
        !filterSearchRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener('click', handleClickOutsideFilterSearch);

    return () => {
      document.removeEventListener('click', handleClickOutsideFilterSearch);
    };
  }, [isOpen]);

  const renderOptions = options.map((option) => {
    const { label, value: optionValue } = option;
    const isSelected = optionValue === value;

    function handleOptionClick() {
      handleChange(optionValue);
      setIsOpen(false);
    }

    return (
      <S.Option
        key={optionValue}
        onClick={isSelected ? undefined : handleOptionClick}
        $isSelected={isSelected}
        type="button"
      >
        {label}
      </S.Option>
    );
  });

  return (
    <S.Main id={id} ref={filterSearchRef}>
      <S.Button type="button" onClick={() => setIsOpen(true)}>
        {options.find((option) => option.value === value)?.label}

        <S.Icon>
          <MdKeyboardArrowDown />
        </S.Icon>
      </S.Button>

      {isOpen && <S.Content>{renderOptions}</S.Content>}
    </S.Main>
  );
}
